module.exports = __webpack_public_path__ + "docs/assets/fonts/Roboto-Italic-cebd892d1acfcc455f5e52d4104f2719.ttf";